"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vipCargo: {
    por: '接货地',
    pol: '装货港',
    etd: 'ETD',
    agtd: 'Updated ETD',
    atd: 'ATD',
    pod: '卸货港',
    del: '目的地',
    eta: 'ETA',
    agta: 'Updated ETA',
    ata: 'ATA',
    vessel: '船名',
    voyage: '航次',
    blNo: '提单号',
    baseInfo: '基本信息',
    currentVesselMovement: '当前航次动态',
    nextLeg: '下一航次',
    bkLane: '订舱航线',
    bkVVL: '订舱船名航次',
    lane: '航线',
    vvl: '船名航次',
    containerNo: '箱号',
    containerType: '箱型',
    sealNo: '铅封号',
    cargoType: '货物类型',
    quantity: '数量',
    weight: '重量',
    size: '尺寸',
    currentPort: '当前动态港口',
    latestMovement: '最新动态',
    eventDate: '发生时间',
    eventPort: '港口',
    movementNameEn: '动态',
    moreInfo: '更多信息',
    bookingParty: '订舱单位',
    PIC: '订舱部门',
    brokersPIC: '订舱负责人',
    shipper: '托运人',
    consignee: '收货人',
    teu: 'TEU',
    freightName: '客户名称',
    freightNameCn: '客户名称',
    actualDays: '实际航行',
    estimatedDays: '预计航行',
    view: '查看',
    excel: 'Excel导出',
    reset: '重置'
  }
};